<template>
  <div class="h-min-content max-w-full">
    <div class="px-4 py-6 bg-white rounded-2xl shadow-lg mx-4">
      <div
        class="max-w-4xl mx-auto grid grid-cols-1 lg:grid-cols-1 justify-center items-start gap-8"
      >
        <div
          class="w-full max-w-xl mx-auto px-0 py-6 bg-white rounded-2xl shadow-lg"
        >
          <h2 class="mb-2 text-2xl md:text-3xl text-blue-dark">
            <b>Queja contra un emisor de valores</b>
          </h2>

          <div class="border border-blue-dark" />

          <div class="text-left mt-5 px-4">
            <a-timeline>
              <a-timeline-item>
                Emisor de valores son las sociedades que tienen valores
                inscritos en el Registro Nacional de Valores y Emisores (RNVE).
              </a-timeline-item>
              <a-timeline-item class="pb-0">
                Para continuar con el trámite, confirme si su caso corresponde a
                un emisor de valores respondiendo las siguientes preguntas con
                Sí o No:
              </a-timeline-item>
            </a-timeline>

            <form @submit.prevent="checkAnswers" class="w-full mb-2">
              <div class="w-full mb-5">
                <div class="w-full">
                  <BaseRadio
                    name="questionOne"
                    id="questionOne"
                    label="¿Es usted titular de acciones, bonos, papeles comerciales, u otro valor de un emisor de valores?"
                    :radioOptions="optionsYN"
                    v-model="questionOne"
                    required="true"
                  />
                  <BaseRadio
                    name="questionTwo"
                    id="questionTwo"
                    label="¿La queja está relacionada con traspaso accionario, pago de dividendos, entre otros relacionados con los valores, o con las actuaciones de la asamblea general de accionistas, junta directiva o representantes legales de un emisor de valores - RNVE?"
                    :radioOptions="optionsYN"
                    v-model="questionTwo"
                    required="true"
                  />
                </div>
              </div>
              <p
                v-if="feedback && feedback !== ''"
                class="text-sm text-center text-red-500 mt-8"
                aria-live="polite"
              >
                {{ feedback }}
              </p>

              <div class="form-group w-full mt-9 text-left flex flex-col">
                <div class="flex flex-col gap-3">
                  <a-button
                    id="register-button"
                    type="primary"
                    shape="round"
                    html-type="submit"
                    :block="true"
                    :loading="loading"
                    >ACEPTAR</a-button
                  >
                  <a-button
                    type="danger"
                    shape="round"
                    :block="true"
                    ghost
                    @click="returnHome"
                    >VOLVER</a-button
                  >
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
    <Modal v-if="viewModal" size="md">
      <div class="text-justify">
        <h3 class="text-blue-700 text-2xl mt-2 mb-4">
          Queja contra un emisor de valores
        </h3>
        <p class="mt-4">
          La queja no hace parte de una inconformidad sobre un emisor de
          valores, por favor revise las distintas opciones para radicar su
          solicitud.
        </p>
      </div>
      <div class="text-center">
        <button
          @click="returnHome"
          class="mt-4 py-2 px-4 bg-blue-500 text-white rounded-lg"
        >
          ACEPTAR
        </button>
      </div>
    </Modal>
  </div>
</template>

<script>
export default {
  data() {
    return {
      disableButton: false,
      feedback: "",
      loading: false,
      optionsYN: [
        { id: 1, name: "Sí" },
        { id: 2, name: "No" },
      ],
      questionOne: "",
      questionTwo: "",
      viewModal: false,
    };
  },
  methods: {
    checkAnswers() {
      this.loading = true;
      this.disableButton = true;

      if (this.questionOne === "" || this.questionTwo === "") {
        this.feedback = "Debe responder todas las preguntas";
        this.loading = false;
        this.disableButton = false;
        return;
      }

      if (
        this.questionOne === 2 ||
        this.questionTwo === 2 ||
        (this.questionOne === 2 && this.questionTwo === 2)
      ) {
        this.loading = false;
        this.disableButton = false;
        this.viewModal = true;
        return;
      }

      this.$router.push({
        path: "/dashboard/complaints-emisor/new"         
      });
    },
    returnHome() {
      this.$router.push("/dashboard").catch(() => {});
    },
  },
  watch: {
    questionOne() {
      this.feedback = "";
    },
    questionTwo() {
      this.feedback = "";
    },
  },
};
</script>
